import { render, staticRenderFns } from "./CalendarPeriods.vue?vue&type=template&id=78dbcb9e"
import script from "./CalendarPeriods.vue?vue&type=script&lang=js"
export * from "./CalendarPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports